import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useRole } from "../context/RoleContext";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";

const MainLayout = () => {
  const { currentMode, loading } = useRole();

  if (loading) return <div>Chargement...</div>;

  if (!currentMode) return <Navigate to="/login" />;

  return (
    <div className="app-container">
      <Sidebar />

      <div className="main-content">
        <TopBar />

        <div className="page-content">
          <Outlet /> {/* Ici s'affiche la page du router */}
        </div>
      </div>
    </div>
  );
};

export default MainLayout;


